import {DateTime} from "luxon";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {pluralize} from "../../helpers/helpers";
import {toRootRelativeImagePath} from "../../helpers/imagePaths";
import SpeciesList from "../species-list";
import type {UpcomingTargetListProps} from "./types";
import './upcoming-target-list.scss';

export default function UpcomingTargetList({title, intro, icon, targets, speciesImages, emptyMessage}: UpcomingTargetListProps) {
    return (
        <section className="upcoming-target-list" aria-labelledby={`upcoming-targets-${title.toLowerCase().replaceAll(' ', '-')}`}>
            <header className="upcoming-target-list__header">
                <FontAwesomeIcon icon={icon} aria-hidden="true" />
                <div>
                    <p className="upcoming-target-list__eyebrow">Upcoming Targets</p>
                    <h2 id={`upcoming-targets-${title.toLowerCase().replaceAll(' ', '-')}`}>{title}</h2>
                    <p>{intro}</p>
                </div>
            </header>
            {targets.length ? <SpeciesList
                className="upcoming-target-list__grid"
                items={targets.map(target => ({
                    id: target.speciesKey,
                    commonName: target.commonName,
                    scientificName: target.scientificName,
                    imageUrl: toRootRelativeImagePath(speciesImages?.[target.taxonomicOrder ?? '']?.thumb) || '/assets/fallback-bird.svg',
                    observationCount: target.yearsSeen,
                    detailPath: target.detailPath,
                    meta: <div className="species-list__meta">Seen in {target.yearsSeen} of {target.historicalYears} {pluralize(target.historicalYears, 'prior year')} · Last recorded {DateTime.fromISO(target.recentSightings[0]?.date ?? target.expectedDate).toFormat('LLL d, yyyy')}</div>,
                    footer: null,
                    lowerContent: <div className="upcoming-target-list__recent"><span>Recent nearby sightings</span><ul className="upcoming-target-list__sightings">{target.recentSightings.map(sighting => <li key={`${sighting.date}-${sighting.location ?? ''}`}><time dateTime={sighting.date}>{DateTime.fromISO(sighting.date).toFormat('LLL d, yyyy')}</time>{sighting.location ? <span>{sighting.location}</span> : null}</li>)}</ul></div>
                }))}
            /> : <p className="upcoming-target-list__empty">{emptyMessage}</p>}
        </section>
    );
}
